export default {
  CANCEL_APPOINTMENT: {
    WITHIN_2HR: {
      title: 'Appointment is Within 2 Hours',
      subtitle: 'Please contact the clinic to cancel.',
      severity: 'info'
    },
    ERROR: {
      title: "We're Sorry",
      subtitle: 'Your appointment could not be cancelled at this time.',
      severity: 'error'
    },
    SUCCESS: {
      title: 'Success!',
      subtitle: 'Your appointment was successfully cancelled.',
      severity: 'success'
    }
  },
  RESCHEDULE_APPOINTMENT: {
    WITHIN_2HR: {
      title: 'Appointment is Within 2 Hours',
      subtitle: 'Please contact the clinic to reschedule.',
      severity: 'info'
    },
    ERROR: {
      title: "We're Sorry",
      subtitle: 'Your appointment cannot be modified at this time.',
      severity: 'error'
    }
  },
  APPT_WITHIN_2_HOURS: 'Appointment is within 2 hours.',
  CANNOT_CANCEL_APPT: 'Please contact Clinic/Provider to cancel.',
  CANNOT_RESCHEDULE_APPT: 'Please contact Clinic/Provider to reschedule.',
  CANNOT_CANCEL_OR_RESCHEDULE_APPT: 'Please contact Clinic/Provider to cancel or reschedule.',
  DEFAULT: 'If you would rather call to cancel or reschedule, please contact the clinic.'
};
